import React, {
  ReactElement,
  useState,
  useRef,
  ChangeEvent,
  useEffect,
  useLayoutEffect
} from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import './index.less';
import check from '@assets/check.png';
import axios from 'axios';
import arrow from '@assets/arrow-grey.png';
import Picker, { TArea } from '../../../../components/city-picker/index';
import Toast from '../../../../components/toast';
import { applyOrder, getInstallProgress } from '../../../../api/filling-pile';
import { getAmapHost, getLoginInfoPromise, getPlatform } from '../../../../utils/common';
import { navHide } from '../../../../utils/common'
import FullLoading from '../../../../components/full-loading';
import { PHONE_REG } from "../../../../utils/reg"
const ApplyIntall = (): ReactElement => {
  interface Form {
    contactName: string;
    contactMobile: string;
    city: string;
    address: string;
  }
  interface Province {
    provinceName: string;
    provinceCode: string;
  }
  const loc = useLocation();
  const router = useHistory();
  const orderNo: any = new URLSearchParams(loc.search).get('orderNo');
  const [areaAddress, setAreaAddress] = useState<string>();
  const [areaAddressList, setAreaAddressList] = useState<TArea[]>([]);
  const [disable, setDisable] = useState<boolean>(false);
  const [show, setShow] = useState<boolean>(false);
  const [areaList, setAreaList] = useState<TArea[]>([]);
  const [isShowTips, setIsShowTips] = useState<boolean>(false);
  const btn = useRef<any>(null);
  const addressRef = useRef<any>(null);
  const setTitle = () => {
    document.title = '报装家充桩';
  };
  const showPicker = () => {
    setShow(true);
  };
  const [formInfo, setFrom] = useState<Form>({
    contactName: '',
    contactMobile: '',
    city: '',
    address: ''
  });

  const getAreaList = () => {
    axios({
      url: `${getAmapHost()}/v3/config/district`,
      data: {},
      params: {
        key: '6657470c50268b502426e5f406d1a444',
        subdistrict: 3,
        extensions: 'base'
      },
      method: 'GET'
    })
      .then((result: any) => {
        const { infocode, info, districts } = result.data;
        if (!['10000'].includes(infocode)) {
          console.log('服务器开小差:' + info);
          return;
        }
        let areaList =
          (districts && !!districts.length && districts[0].districts) ||
          ([] as TArea[]);
        let newAreaList = areaList.filter((item: TArea) => {
          return !['810000', '820000', '710000'].includes(
            item.adcode as string
          );
        });
        setAreaList(newAreaList);
      })
      .catch((err: any) => {
        console.log('err', err);
      });
  };

  //获取渠道
  const getSource = () => {
    getLoginInfoPromise().then(res => {
      getInstallProgress({ uid: res.uid, orderNo: orderNo }).then(res => {
        console.log(res.data.createSource);
        if (res.data.createSource === 2) {
          setIsShowTips(true);
        }
      });
    });
  };

  useEffect(() => {
    //监听页面尺寸变化
    addEventListener('resize', function() {
      // 解决键盘弹起后遮挡输入框的问题
      if (
        document.activeElement &&
        (document.activeElement.tagName == 'INPUT' ||
          document.activeElement.tagName == 'TEXTAREA')
      ) {
        window.setTimeout(function() {
          document.activeElement && document.activeElement.scrollIntoView();
        }, 0);
      }
    });
  }, []);
  useLayoutEffect(() => {
    // 隐藏导航栏
    navHide();
  }, []);

  useEffect(() => {
    const handleNavHide = () => {
      navHide();
      setTimeout(() => {
        navHide();
      }, 100);
    }; // 100 毫秒内最多执行一次

    document.addEventListener('visibilitychange', handleNavHide);

    // 清理事件监听器
    return () => {
      document.removeEventListener('visibilitychange', handleNavHide);
    };
  }, []);

  useEffect(() => {
    setTitle();
    getAreaList();
    getSource();
  }, []);
  useEffect(() => {
    if (
      formInfo.contactName &&
      formInfo.contactMobile &&
      areaAddressList[0] &&
      formInfo.address
    ) {
      setDisable(false);
      btn.current.classList.add('btn-active');
      return;
    }
    setDisable(true);
    btn.current.classList.remove('btn-active');
  }, [formInfo]);
  const onSure = (selectedIndexs: TArea[]) => {
    console.log('地区',selectedIndexs);

    const tempAreaAddress = selectedIndexs.map(item => item.name).join('');
    setAreaAddress(tempAreaAddress);
    setAreaAddressList(selectedIndexs);
    setShow(false);
  };

  const submitInstallation = () => {
    if (
      !formInfo.contactName ||
      !formInfo.contactMobile ||
      !formInfo.address ||
      !areaAddressList[0]
    ) {
      Toast.show({
        text: '请确保准确填写信息',
        duration: 2000
      });
      return;
    }
    if (!areaAddressList[2].name) {
      Toast.show({
        text: '请选择完整的省市区',
        duration: 2000
      });
      return;
    }
    if (!formInfo.contactMobile || !PHONE_REG.test(formInfo.contactMobile) || formInfo.contactMobile.length !== 11 ) {
      Toast.show({
        text: '请输入正确的手机号',
        duration: 2000
      });
      return;
    }

    FullLoading.show({
      text: '提交中'
    });
    const phoneModel = getPlatform();
    getLoginInfoPromise()
      .then(res => {
        let name: string = res.username;
        if (phoneModel === 'android') {
          name = res.nickname;
        }
        applyOrder({
          uid: res.uid,
          name: name,
          phone: res.mobile,
          orderNo: orderNo,
          contactName: formInfo.contactName,
          contactPhone: formInfo.contactMobile,
          province: areaAddressList[0].name as string,
          provinceCode: areaAddressList[0].adcode as string,
          city: areaAddressList[1].name as string,
          cityCode: areaAddressList[1].adcode as string,
          district: areaAddressList[2].name as string,
          districtCode: areaAddressList[2].adcode as string,
          address: formInfo.address
        })
          .then(res => {
            FullLoading.hide();
            if (res.data.code === 200) {
              Toast.show({
                text: '提交成功',
                duration: 2000
              });
              router.push({
                pathname: '/pile-installation',
                search: '?orderNo=' + (orderNo ? orderNo : '')
              });
            }
          })
          .catch(err => {
            FullLoading.hide();
            console.log(err),
              Toast.show({
                text: err.message,
                duration: 2000
              });
          });
      })
      .catch(() => {
        FullLoading.hide();
      });
  };
  const contactName = (e: ChangeEvent<HTMLInputElement>) => {
    e.persist();
    let object = JSON.parse(JSON.stringify(formInfo));
    object.contactName = e.target.value;
    setFrom(object);
  };
  const contactMobile = (e: ChangeEvent<HTMLInputElement>) => {
    e.persist();
    // let value = e.target.value.replace(/[^\d]/g, '');
    let object = JSON.parse(JSON.stringify(formInfo));
    object.contactMobile = e.target.value;
    setFrom(object);
  };
  const address = e => {
    //关键是先设置为auto，目的为了重设高度（如果字数减少）
    if (addressRef.current) {
      addressRef.current.style.height = 'auto';
    }
    //如果高度不够，再重新设置
    if (
      addressRef.current &&
      addressRef.current.scrollHeight >= addressRef.current.offsetHeight
    ) {
      addressRef.current.style.height = addressRef.current.scrollHeight + 'px';
    }
    let object = JSON.parse(JSON.stringify(formInfo));
    object.address = e.target.value;
    setFrom(object);
  };

  return (
    <div className="home">
      <div className="content">
        <div className="schedule">
          <div className="steps">
            <img src={check} alt="" className="steps-icon"></img>
            <p className="liner2"></p>
            <img src={check} alt="" className="steps-icon"></img>
            <p className="liner2"></p>
            <img src={check} alt="" className="steps-icon"></img>
          </div>
          <div className="steps-title">
            <div className="text">申请报装</div>
            <div className="text">现场勘测</div>
            <div className="text">上门安装</div>
          </div>
        </div>
        <div className="form-info">
          <div className="form-item">
            <span>联系人姓名</span>
            <input
              type="text"
              className="filed"
              placeholder="请输入"
              maxLength={12}
              onChange={e => contactName(e)}
            />
          </div>
          <div className="form-item">
            <span>联系人电话</span>
            <input
              type="tel"
              maxLength={11}
              className="filed"
              placeholder="请输入"
              onChange={e => contactMobile(e)}
            />
          </div>
          <div className="form-item" onClick={showPicker}>
            <span>所在地区</span>
            <div className={`addressValue ${areaAddress ? '' : 'default'}`}>
              {areaAddress ? areaAddress : '请选择'}
            </div>
            <img src={arrow} alt="" className="arrow-icon" />
          </div>
          <div className="form-item">
            <span>详细安装地址</span>
            <textarea
              ref={addressRef}
              placeholder="请输入"
              onChange={address}
              maxLength={400}
              rows={1}
              value={formInfo.address}
            />
          </div>
          {isShowTips ? (
            <React.Fragment>
              <div className="form-line"></div>
              <div className="form-tipsTitle Bold">报装须知：</div>
              <div className="form-tips">
                <div className="tips">
                  1. 为了保护你的权益，上门服务时我们将会核对你的
                  <span className="Bold">购车合同或合同签署人身份证件；</span>
                  若你无法提供证件 或
                  证件信息与实际权益人不一致，我们将停止安装并消耗1次服务次数。
                </div>
                <div className="tips">
                  2. 本家桩可享受 <span className="Bold">1次免费上门勘测</span>{" "}
                  和 <span className="Bold">1次免费上门安装</span>{" "}
                  服务，超出次数的服务将额外收取费用，100元/次。
                </div>
                <div className="tips">
                  3. 具备安装条件后，由我方服务人员带充电桩上门安装。
                </div>
              </div>
            </React.Fragment>
          ) : null}
        </div>
      </div>
      <div className="btn">
        <button
          type="button"
          disabled={disable}
          className="btn-disabled"
          ref={btn}
          onClick={submitInstallation}
        >
          提交申请
        </button>
      </div>
      <Picker
        title="所在地区"
        show={show}
        regionList={areaList}
        onCancel={() => setShow(false)}
        selectedIndexs={[0]}
        onSure={onSure}
      />
    </div>
  );
};

export default ApplyIntall;
